import { Space } from 'antd';
import React, { FC } from 'react';
import { HideForPartner } from 'components/atoms/user-type-utils';
import { AppearanceSettings } from './appearance-settings';
import { CompanyLogoChange } from './company-logo-change';
import { CompanyNameChange } from './company-name-change';
import { SampleData } from './sample-data';
import { AccountTimezone } from './timezone';
import { WeeklyTeamCapacity } from './weekly-team-capacity';

export const OrganisationSettings: FC = () => {
  return (
    <Space size={32} direction="vertical">
      <CompanyLogoChange />
      <CompanyNameChange />
      <HideForPartner>
        <AccountTimezone />
      </HideForPartner>
      <HideForPartner>
        <WeeklyTeamCapacity />
      </HideForPartner>
      <HideForPartner>
        <AppearanceSettings />
      </HideForPartner>
      <HideForPartner>
        <SampleData />
      </HideForPartner>
    </Space>
  );
};
